// import {Config} from "./../config.js"; 
 
const Config = window.$application.config;


//
function gtag() {
    dataLayer.push(arguments);
} 

// 
function addScript(src) {
    var s = document.createElement('script');
    s.setAttribute('src', src);
    s.setAttribute("async", "async");
    s.setAttribute("defer", "defer");
    s.setAttribute("type", "text/javascript");  

    var last_s = document.getElementsByTagName('script')[0];
    last_s.parentNode.insertBefore(s, last_s);
} 

// 
window.dataLayer = window.dataLayer || []; 
window.gtag = gtag;
gtag('js', new Date());
gtag('config', Config.Analytics.id);
addScript("https://www.googletagmanager.com/gtag/js?id=" + Config.Analytics.id);


